(() => {
  const initializeProductPremium = (root = document) => {
    root.querySelectorAll('.product-premium').forEach((section) => {
      if (section.dataset.premiumInitialized === 'true') return;
      section.dataset.premiumInitialized = 'true';

      const quantity = section.querySelector('[data-premium-quantity]');
      const bundles = section.querySelectorAll('[data-premium-bundle]');
      const sticky = document.querySelector('[data-premium-sticky-cart]');
      const buyArea = section.querySelector('[data-premium-buy]');
      const currentMedia = section.querySelector('[data-premium-media-current]');

      const syncQuantity = (value) => {
        const safeValue = Math.max(1, Number.parseInt(value, 10) || 1);
        if (quantity) {
          quantity.value = safeValue;
          quantity.dispatchEvent(new Event('change', {bubbles: true}));
        }
        document.querySelectorAll('[data-premium-sticky-quantity]').forEach((input) => {
          input.value = safeValue;
        });
      };

      quantity?.addEventListener('change', () => syncQuantity(quantity.value));

      bundles.forEach((bundle) => {
        bundle.addEventListener('click', () => {
          bundles.forEach((item) => item.classList.remove('is-selected'));
          bundle.classList.add('is-selected');
          syncQuantity(bundle.dataset.quantity);
        });
      });

      section.querySelectorAll('[data-target]').forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          if (currentMedia) currentMedia.textContent = String(index + 1);
        });
      });

      if (sticky && buyArea && window.matchMedia('(max-width: 749px)').matches) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            sticky.hidden = entry.isIntersecting;
          },
          {threshold: 0.15}
        );
        observer.observe(buyArea);
      }
    });

    root.querySelectorAll('[data-premium-sticky-cart]').forEach((sticky) => {
      if (sticky.dataset.premiumInitialized === 'true') return;
      sticky.dataset.premiumInitialized = 'true';
      const buyArea = document.querySelector('[data-premium-buy]');
      if (buyArea && window.matchMedia('(max-width: 749px)').matches) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            sticky.hidden = entry.isIntersecting;
          },
          {threshold: 0.15}
        );
        observer.observe(buyArea);
      }
    });

    if (
      !window.__premiumProductVariantSync
      && typeof subscribe === 'function'
      && typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      window.__premiumProductVariantSync = true;
      subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        const variant = data?.variant;
        if (!variant) return;
        document.querySelectorAll('[data-premium-sticky-cart]').forEach((sticky) => {
          const variantInput = sticky.querySelector('.product-variant-id');
          const button = sticky.querySelector('button[name="add"]');
          const price = sticky.querySelector('[data-premium-sticky-price]');
          const sourcePrice = data.html
            ?.querySelector(`#price-${data.sectionId} .price-item--regular`)
            ?.textContent.trim();
          if (variantInput) variantInput.value = variant.id;
          if (button) button.disabled = !variant.available;
          if (price && sourcePrice) price.textContent = sourcePrice;
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductPremium());
  } else {
    initializeProductPremium();
  }

  document.addEventListener('shopify:section:load', (event) => initializeProductPremium(event.target));
})();
